import { Record as record } from 'immutable';
import _ from "lodash";

import { construct, resolveAll } from '../../helpers/LinkMapper';
import CardPayment from './CardPayment';
import HostedCardPayment from './HostedCardPayment';
import WarrantPayment from './WarrantPayment';
import PaypalPayment from './PaypalPayment';
import AlternativePayment from './AlternativePayment';
import GooglePayPayment from './GooglePayPayment';
import ApplePayPayment from './ApplePayPayment';
import BraintreeCardPayment from './BraintreeCardPayment';

const defaults = {
    cards: null,
    hostedCards: null,
    warrants: null,
    paypal: null,
    alternative: null,
    googlePay: null,
    applePay: null,
    cardCheckout: null,
};

export default class OrderPayments extends record(defaults) {

    static fromJSON (json = {}) {
        return construct(OrderPayments, json, {
            cards: Array.isArray(json.cards) ? resolveAll.as(CardPayment) : resolveAll(_.get(json, 'cards.transactions')).as(CardPayment),
            hostedCards: resolveAll.as(HostedCardPayment),
            warrants: resolveAll.as(WarrantPayment),
            paypal: resolveAll.as(PaypalPayment),
            alternative: resolveAll.as(AlternativePayment),
            googlePay: resolveAll.as(GooglePayPayment),
            applePay: resolveAll.as(ApplePayPayment),
            cardCheckout: resolveAll.as(BraintreeCardPayment),
        });

    }

    getCards () {
        return this.cards.size ? this.cards : this.hostedCards;
    }

    hasNonHostedCards () {
        const {cards} = this;
        return cards && cards.size > 0;
    }

    hasHostedCards () {
        const {hostedCards} = this;
        return hostedCards && hostedCards.size > 0;
    }

    hasLatestVoucherPayment () {
        return this.warrants.some(warrant => warrant.hasLatestPayment());
    }

    hasLatestCardPayment () {
        return this.getCards().some(card => card.hasLatestPayment());
    }

    getLatestVoucherPayment () {
        return this.warrants.find(warrant => warrant.hasLatestPayment()).getPaymentAmount();
    }

    getLatestCardPayment () {
        return this.getCards().find(card => card.hasLatestPayment()).getPaymentAmount();
    }

    getLatestCardDetails () {
        return this.getCards().find(card => card.hasLatestPayment());
    }

    getTotal () {
        return Object.values(this.toJS()).reduce((total, payment) => {
            return total + _.sumBy(payment, 'amount');
        }, 0);
    }

}
